import Vue from "vue";
import Vuetify from "vuetify";
import colors from "vuetify/es5/util/colors";
import es from "vuetify/es5/locale/es";
import en from "vuetify/es5/locale/en";
import config from "@/assets/config.js";

const appColors = config.APP.COLORS;
// TODO: Verificar colores de acuerdo al proyecto
Vue.use(Vuetify, {
  lang: {
    locales: { es , en },
    current:  config.lang,
  },
  theme: {
    primary: "#28ad22",
    secondary: "#757575",
    accent: "#28ad22",
    error: "#f44336",
    warning: "#FF9800",
    info: "#2196F3",
    success: "#28ad22",
  },
});
